<template>
  <ValidationObserver ref="form">
    <v-row>
    <v-col cols="12" sm="5" class="py-0">
      <ValidationProvider rules="required" name="sources_restriction" v-slot="{ errors }">
        <v-autocomplete
          v-model="restriction.sources"
          :items="countries"
          item-text="name"
          :label="$t('deliveryMethod.sources')"
          class="d-flex justify-center align-center py-2"
          dense
          hide-details="auto"
          outlined
          multiple
          clearable
          :error-messages="errors"
          :search-input.sync="searchInput.source"
          @change="searchInput.source=''"
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @mousedown.prevent @click.stop="toggleAllSourceCountries()">
              <v-list-item-action>
                <v-checkbox :value="allSourceCountries" hide-details></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("deliveryMethod.selectAll") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip small v-if="allSourceCountries && index === 0">
              {{ $t("deliveryMethod.allCountries") }}
            </v-chip>
            <v-chip small v-else-if="index === 0">
              <span v-if="index === 0">{{ item.name }}</span>
            </v-chip>
            <span
              v-if="index === 1 && !allSourceCountries"
              class="grey--text caption"
            >{{ `(+${restriction.sources.length - 1} ${$t("components.select.others")})` }}</span>
          </template>
        </v-autocomplete>
      </ValidationProvider>
    </v-col>
    <v-col cols="12" sm="5" class="py-0">
      <ValidationProvider rules="required" name="destinations_restriction" v-slot="{ errors }">
        <v-autocomplete
          v-model="restriction.destinations"
          :items="countries"
          item-text="name"
          :label="$t('deliveryMethod.destinations')"
          class="d-flex justify-center align-center py-2"
          dense
          hide-details="auto"
          outlined
          multiple
          clearable
          :error-messages="errors"
          :search-input.sync="searchInput.destinations"
          @change="searchInput.destinations =''"
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @mousedown.prevent @click.stop="toggleAllDestinationCountries()">
              <v-list-item-action>
                <v-checkbox :value="allDestinationCountries" hide-details></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("deliveryMethod.selectAll") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip small v-if="allDestinationCountries && index === 0">
              {{ $t("deliveryMethod.allCountries") }}
            </v-chip>
            <v-chip small v-else-if="index === 0">
              <span v-if="index === 0">{{ item.name }}</span>
            </v-chip>
            <span
              v-if="index === 1 && !allDestinationCountries"
              class="grey--text caption"
            >(+{{ restriction.destinations.length - 1 }} {{$t("deliveryMethod.others")}})</span>
          </template>
        </v-autocomplete>
      </ValidationProvider>
    </v-col>
    <v-col sm="2" class="d-flex justify-center align-center py-0" >
      <span v-if="isNew">
        <v-btn
          color="primary"
          :disabled="!restriction.sources.length || !restriction.destinations.length"
          icon
          @click="$emit('add-restriction')"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn color="primary" icon @click="$emit('cancel')"><v-icon>mdi-close</v-icon></v-btn>
      </span>
      <span v-else>
        <v-btn icon color="error" @click='removeRestriction(restriction)'><v-icon>mdi-delete</v-icon></v-btn>
      </span>
    </v-col>
  </v-row>
  </ValidationObserver>
</template>

<script>
  import { ValidationProvider, ValidationObserver } from "vee-validate"

  export default {
    name: "countriesEligibilitySelectors",
    components: {
      ValidationProvider,
      ValidationObserver
    },
    mounted() {
      this.checkAllDestinationsAreChecked()
      this.checkAllSourcesAreChecked()
    },
    props: {
      restriction: {
        type: Object,
        required: true,
      },
      countries: {
        type: Array,
        required: true
      },
      isNew: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        allSourceCountries: false,
        allDestinationCountries: false,
        searchInput : {
          source: '',
          destinations: ''
        }
      }
    },
    methods: {
      removeRestriction(restriction) {
        this.$emit('remove-restriction', restriction)
      },
      toggleAllDestinationCountries() {
        this.allDestinationCountries = !this.allDestinationCountries
        if(this.allDestinationCountries){
          this.restriction.destinations = this.countries.map(country => country.value)
        } else {
          this.restriction.destinations = []
        }
      },
      toggleAllSourceCountries() {
        this.allSourceCountries = !this.allSourceCountries
        if(this.allSourceCountries){
          this.restriction.sources = this.countries.map(country => country.value)
        } else {
          this.restriction.sources = []
        }
      },
      checkAllDestinationsAreChecked(){
        if(this.restriction.destinations.length === this.countries.length){
          this.allDestinationCountries =  true
        } else {
          this.allDestinationCountries =  false
        }
      },
      checkAllSourcesAreChecked(){
        if(this.restriction.sources.length === this.countries.length){
          this.allSourceCountries =  true
        } else {
          this.allSourceCountries =  false
        }
      }
    },
    watch: {
      'restriction.destinations'() {
        this.checkAllDestinationsAreChecked()
      },
      'restriction.sources'() {
        this.checkAllSourcesAreChecked()
      },
    }
  };
</script>

